import { render } from "./HeadjointsView.vue?vue&type=template&id=4371c3e4&scoped=true&ts=true"
import script from "./HeadjointsView.vue?vue&type=script&lang=ts"
export * from "./HeadjointsView.vue?vue&type=script&lang=ts"

import "./HeadjointsView.vue?vue&type=style&index=0&id=4371c3e4&scoped=true&lang=css"
import "@/assets/css/style.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4371c3e4"]])

export default __exports__